



















































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { DialogForm, FormOverlay } from '@/components/bwaff';

import api from '@/services/utils/base';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import Form from '@/components/form-base';
import GetUsingTypeMixin from '@/i18n/getUsingType-mixin';
import { mixins } from 'vue-class-component';

interface Workspace {
  type?: 'private' | 'public';
  name?: string;
  id?: string;
}

interface Conflict {
  usedItems: string[];
  allUsages: null | number;
}

@Component({
  components: {
    FormOverlay,
    DialogForm,
    ErrorAggregator,
  },
})
export default class ChangeWorkspaceDialog extends mixins(Form,GetUsingTypeMixin) {
  active: boolean = false;

  selectedWorkspace: Workspace = {};

  defaultConflictState: Conflict = {
    usedItems: [],
    allUsages: null,
  };

  conflict = {
    ...this.defaultConflictState,
  };

  errors: any[] = [];
  errorsControlActive: boolean = false;

  close() {
    this.$emit('close');
  }

  get selectedItem() {
    return this.$store.getters.selectedItem;
  }

  get selectedItemWorkspaceType() {
    return this.$store.state.user.workspaces.find(
      item => item.id === this.selectedItem.id,
    )?.type;
  }

  get workspacesList() {
    if (this.$route.params.type === 'campaigns') {
      return this.$store.state.user.workspaces.filter(
        item => item.type !== 'public' && item.id !== this.selectedItem.workspaceId,
      );
    } else {
      return this.$store.state.user.workspaces.filter(
        item => item.id !== this.selectedItem.workspaceId,
      );
    }
  }

  get isFromPrivateToPublic() {
    return (
      this.selectedWorkspace.type === 'private' &&
      this.selectedItemWorkspaceType === 'public'
    );
  }

  get isFromPublicToPrivate() {
    return (
      this.selectedWorkspace.type === 'public' &&
      this.selectedItemWorkspaceType === 'private'
    );
  }

  get isFromPrivateToPrivate() {
    return (
      this.selectedWorkspace.type === 'private' &&
      this.selectedItemWorkspaceType === 'private'
    );
  }

  @Watch('selectedWorkspace')
  onWorkspaceChanged() {
    this.resetErrorAggregator();
    this.conflict = { ...this.defaultConflictState };
  }

  resetErrorAggregator() {
    this.errors = [];
    this.errorsControlActive = false;
  }

  mounted() {
    this.active = true;
    this.$on('error', (e: any) => {
      this.errors = this.translateErrors(
        this.parseErrors(e.data.errors),
        e.data.message,
      );
      this.errorsControlActive = true;
    });
  }

  submit() {
    if (!this.selectedWorkspace.id) {
      this.errorsControlActive = true;
      Vue.set(
        this.state,
        'selectedWorkspace:error',
        this.t('Workspace should be selected'),
      );
      this.errors = [
        this.t('Validation failed'),
        this.t('Workspace should be selected'),
      ];
      return;
    }

    const elementId = this.selectedItem?.id;
    api.patch(`${this.$route.params.type}/${elementId}/change-workspace`, {
        workspaceId: this.selectedWorkspace.id,
      })
      .then(() => {
        this.bus.emit('refresh-report');
        this.close();
        this.bus.emit(
          'toast-success',
          this.t('Workspace changed successfully'),
        );
      })
      .catch(error => {
        const { message, payload } = error.response.data;
        const { usedItems, allUsages } = payload;
        if (message === 'WORKSPACE_CONFLICT') {
          this.conflict = {
            usedItems,
            allUsages,
          };
          this.errors = [
            this.t('Moving this element to other workspace is not possible.'),
          ];
        }
      });
  }
}
